import React from 'react';
import Draggable from 'react-draggable';
import ThreeDViewer, { ThreeDViewerProps } from '../Visualizer';
import { containerStyle, handleStyle } from './DraggableThreeDViewer.style';

const DraggableThreeDViewer: React.FC<ThreeDViewerProps> = props => {
  return (
    <Draggable handle=".drag-handle">
      <div style={containerStyle}>
        <div className="drag-handle" style={handleStyle}>
          ☰
        </div>
        <ThreeDViewer {...props} />
      </div>
    </Draggable>
  );
};

export default DraggableThreeDViewer;
